import { GridItemPosition, GridItemSize } from 'Vendor/Utils/StudioTypes'
import EntityInterface from 'Vendor/Definition/EntityInterface'
import React from 'react'
import File from 'Entity/File'

export interface AssetItem {
    id: string
    type: 'TEXT' | 'PRODUCT' | 'FILE' | 'COLOR' | 'EXTERNAL_IMAGE'
    content: {
        text?: string
        src?: string
        alt?: string
        color?: string
    }
    collectionSlug?: string
    itemId?: number
    contentType?: 'file' | 'product' | 'external'
}

export interface LayoutItem {
    id: string
    assetId: string
    position: GridItemPosition
    size: GridItemSize
    styles: React.CSSProperties
    zIndex: number
}

export type ActiveLayoutItem = LayoutItem & {
    type: AssetItem['type']
    content: AssetItem['content']
    itemId?: number
    collectionSlug?: string
    contentType?: AssetItem['contentType']
}

export interface LayoutState {
    items: Record<string, LayoutItem>
    itemIds: string[]
}

export interface PageData {
    id: string
    name: string
    assets: Record<string, AssetItem>
    layouts: {
        desktop: LayoutState
        mobile: LayoutState
    }
    selectedItemIds: string[]
}

export interface StudioState {
    creationId?: number
    pages: Record<string, PageData>
    pageIds: string[]
    activePageId: string
    coverImage?: File | null
    responsiveMode: 'desktop' | 'mobile'
    status: 'idle' | 'loading' | 'succeeded' | 'failed'
    error: string | null
    zoomLevel: number
    selectedItemsByCollection: {
        [creationId: number]: {
            [collectionSlug: string]: EntityInterface[]
        }
    }
    isGridVisible: boolean,
}

export const initialLayoutState: LayoutState = {
    items: {},
    itemIds: [],
}

export function createNewPageData(id: string, name: string): PageData {
    return {
        id: id,
        name: name,
        assets: {},
        layouts: {
            desktop: initialLayoutState,
            mobile: initialLayoutState,
        },
        selectedItemIds: [],
    }
}

const firstPageId = generateTempUUID()
export const initialPageData = createNewPageData(firstPageId, 'Page 1')

export const initialState: StudioState = {
    creationId: undefined,
    pages: {
        [firstPageId]: initialPageData,
    },
    pageIds: [firstPageId],
    activePageId: firstPageId,
    coverImage: null,
    responsiveMode: 'desktop',
    status: 'idle',
    error: null,
    zoomLevel: 1.0,
    selectedItemsByCollection: {},
    isGridVisible: true,
}

export function generateTempUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}
